import { Image } from '@chakra-ui/react';

import { ThemeIcon, ThemeIconProps } from '../../components';
import LightLogo from './assets/vivalto_dark.svg';
import DarkLogo from './assets/vivalto_light.svg';

function LightIcon(): JSX.Element {
  return <Image alt="Vivalto" height="100%" src={LightLogo} width="full" />;
}

function DarkIcon(): JSX.Element {
  return <Image alt="Vivalto" height="100%" src={DarkLogo} />;
}

export function Icon({ ...props }: ThemeIconProps): JSX.Element {
  return <ThemeIcon darkIcon={<DarkIcon />} lightIcon={<LightIcon />} {...props} />;
}
